import { useState } from "react";
import { getCookie, setCookie } from "../utils/cookiesHelper";

export const useCookies = (key, initialValue) => {
  const [item, setItem] = useState(() => {
    return getCookie(key, initialValue);
  });

  const updateItem = (value, options) => {
    setItem(value);
    setCookie(key, value, options);
  };

  return [item, updateItem];
};
